import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const adminKF: AppRouteModule = {
  path: '/admin/kf',
  name: 'adminKF',
  component: LAYOUT,
  // redirect: 'admin',
  meta: {
    orderNo: -100,
    icon: 'ant-design:tool-outlined',
    title: '系统管理',
  },
  children: [
    {
      path: 'user',
      name: 'User',
      component: () => import('/@/views/admin/user/User.vue'),
      meta: {
        title: '用户管理',
        icon:'ant-design:user-outlined'
      },
    },
    {
      path: 'role',
      name: 'Role',
      component: () => import('/@/views/admin/role/Role.vue'),
      meta: {
        title: '角色管理',
        icon:'ant-design:usergroup-add-outlined'
      },
    },
    {
      path: 'permission',
      name: 'Permission',
      component: () => import('/@/views/admin/permission/Permission.vue'),
      meta: {
        title: '权限管理',
        icon:'ant-design:unlock-outlined'
      },
    },
    {
      path: 'menu',
      name: 'Menu',
      component: () => import('/@/views/admin/menu/Menu.vue'),
      meta: {
        title: '菜单管理',
        icon:'ant-design:ordered-list-outlined'
      },
    },
    {
      path: 'dictionaries',
      name: 'Dictionaries',
      component: () => import('/@/views/admin/dic/Dictionaries.vue'),
      meta: {
        title: '数据字典',
        icon:'ant-design:code-outlined'
      },
    },
    {
      path: 'biz',
      name: 'Biz',
      component: () => import('/@/views/admin/biz/Biz.vue'),
      meta: {
        title: '业务单元',
        icon:'ant-design:hdd-outlined'
      },
    },
    {
      path: 'channel',
      name: 'Channel',
      component: () => import('/@/views/admin/channel/Channel.vue'),
      meta: {
        title: '渠道管理',
        icon:'ant-design:pull-request-outlined'
      },
    },
    {
      path: 'taggroup',
      name: 'TagGroup',
      component: () => import('/@/views/admin/taggroup/Tag.vue'),
      meta: {
        title: '标签管理',
        icon:'ant-design:copy-outlined'
      },
    },
    {
      path: 'merchant',
      name: 'Nerchant',
      component: () => import('/@/views/admin/merchant/Merchant.vue'),
      meta: {
        title: '商户管理',
        icon:'ant-design:idcard-outlined'
      },
    },
    {
      path: '/service/notice',
      name: 'Notice',
      component: () => import('/@/views/service/Notice.vue'),
      meta: {
        title: '公告管理',
        icon:'ant-design:profile-outlined'
      },
    },
  ],
};

export default adminKF;
